import { useDispatch } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@mui/system/styled';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import { collapseDrawerWidth, drawerWidth } from 'store/constant';
import { setMenu } from 'store/features/customizationSlice';

const DrawerStyled = styled('div')(({ theme }) => ({
  background: 'white',
  width: collapseDrawerWidth,
  position: 'sticky',
  top: 80,

  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),

  [theme.breakpoints.down('lg')]: {
    position: 'fixed',
    top: 0,
    left: -drawerWidth,
    bottom: 0,
    zIndex: 2000,
    width: drawerWidth,
    boxShadow: theme.shadows[6],
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },

  variants: [
    {
      props: ({ open }) => open,

      style: {
        width: drawerWidth
      }
    },
    {
      props: ({ open }) => open,

      style: {
        [theme.breakpoints.down('lg')]: {
          left: 0
        }
      }
    }
  ]
}));

const DrawerOverlay = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(9, 0, 0, 0.7)',
    zIndex: 1900,
    opacity: 0,
    visibility: 'hidden',
    transition: theme.transitions.create(['opacity', 'visibility'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },

  variants: [
    {
      props: ({ open }) => open,

      style: {
        [theme.breakpoints.down('lg')]: {
          opacity: 1
        }
      }
    },
    {
      props: ({ open }) => open,

      style: {
        [theme.breakpoints.down('lg')]: {
          visibility: 'visible'
        }
      }
    }
  ]
}));

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const drawer = (
    <>
      <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
        <Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
          <LogoSection />
        </Box>
      </Box>
      <BrowserView>
        <PerfectScrollbar
          component="div"
          style={{
            height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingTop: '20px'
          }}
        >
          <MenuList />
        </PerfectScrollbar>
      </BrowserView>
      <MobileView>
        <PerfectScrollbar
          component="div"
          style={{
            height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
            paddingLeft: '16px',
            paddingRight: '16px'
          }}
        >
          <MenuList />
        </PerfectScrollbar>
      </MobileView>
    </>
  );

  return (
    <>
      <div>
        <DrawerStyled open={drawerOpen}>{drawer}</DrawerStyled>
      </div>
      <DrawerOverlay open={drawerOpen} onClick={() => dispatch(setMenu({ opened: false }))} />
    </>
  );
};

export default Sidebar;
